import { render, staticRenderFns } from "./AddToBlocked.vue?vue&type=template&id=1dd338ac&scoped=true&"
import script from "./AddToBlocked.vue?vue&type=script&lang=js&"
export * from "./AddToBlocked.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/relation_btn.css?vue&type=style&index=0&id=1dd338ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd338ac",
  null
  
)

export default component.exports